export interface BookingSelection {
  orderIds: Array<string>
  itemIds: Array<string>
}

export function addBookingItemIdsToSelection(
  previous: BookingSelection,
  bookingItemIds: Array<string>,
): BookingSelection {
  return {
    ...previous,
    itemIds: [...new Set([...previous.itemIds, ...bookingItemIds])],
  }
}
